/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';

const __vue_script__ = {
    name: 'MeetingsVisibilityInput',

    components: { RadioButtons, TargetingControl },

    props: {
        event: {
            required: true,
            type: Object
        },

        value: {
            type: [Object, String],
            default: 'all'
        },

        options: {
            type: Object,
            default: () => ({})
        },

        model: {
            type: Object,
            default: () => ({})
        },

        name: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            option: 'all',
            radioOptions: ['all', 'no_one', 'custom'].map(value =>
                ({ label: this.$t(`meetings.settings.visibility.${value}`), value })
            ),
            showTargeting: false,
            targeting: {},
        };
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(val) {
                if (this.isTargeting(val)) {
                    this.option = 'custom';
                    this.showTargeting = true;
                    this.targeting = val;
                }
                if (this.option === 'custom') return this.setBadge();
                this.showTargeting = false;
                this.targeting = {};
                this.option = val === 'no_one' ? val : 'all';
                this.setBadge();
            },
        }
    },

    methods: {
        isTargeting(d) {
            return Array.isArray(d?.targets) && d.targets.length
                || Array.isArray(d?.exceptions) && d.exceptions.length;
        },

        onOptionChange(option) {
            this.showTargeting = option === 'custom';
            this.$emit('input', option === 'no_one' ? 'no_one' : 'all');
            this.setBadge();
        },

        onTargetingChange(targeting) {
            if (this.option !== 'custom') return;
            this.$emit('input', this.isTargeting(targeting) ? targeting : 'all');
        },

        setBadge() {
            window.dispatchEvent(new CustomEvent(
                'set-form-category-badge',
                {
                    detail: {
                        inputName: this.name,
                        label: this.$t(`meetings.settings.visibility.${this.option}`),
                    },
                },
            ));
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meetings-visibility-input"},[_c('p',[_c('small',[_vm._v(_vm._s(_vm.$t('meetings.settings.visibility.description')))])]),_c('radio-buttons',{attrs:{"name":"meetings_visibility","options":_vm.radioOptions},on:{"input":_vm.onOptionChange},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}}),(_vm.showTargeting)?_c('targeting-control',{attrs:{"name":"meetings_visibility_targeting","visible-to-label":_vm.$t('meetings.settings.visibility.visible_to_label'),"visible-to-desc":_vm.$t('meetings.settings.visibility.visible_to_desc'),"hidden-to-label":_vm.$t('meetings.settings.visibility.hidden_to_label'),"hidden-to-desc":_vm.$t('meetings.settings.visibility.hidden_to_desc'),"expandable":false,"event-id":_vm.event._id},on:{"input":_vm.onTargetingChange},model:{value:(_vm.targeting),callback:function ($$v) {_vm.targeting=$$v},expression:"targeting"}}):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MeetingsVisibilityInput.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__